(() => {
  const init = (root) => {
    const wrap = root.querySelector('[data-lspd-features]');
    const button = root.querySelector('[data-lspd-toggle]');
    if (!wrap || !button || wrap.dataset.lspdReady) return;
    wrap.dataset.lspdReady = 'true';

    wrap.classList.add('lspd--collapsible');
    button.hidden = false;

    button.addEventListener('click', () => {
      const expanded = wrap.classList.toggle('lspd--expanded');
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
      if (!expanded) wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-section-type="ls-playset-details"]').forEach(init);
  };

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
